<template>

  <div>
    <PageHeader title="Define Micro Notes">

      <a v-if="lectureNote && microNotable()" slot="top" v-on:click.prevent="convertToMicroNotes" href class="btn btn-primary btn-lg" style="float:right;margin-left:10px;">
        <i class="fas fa-save"></i> &nbsp; Create micro notes
      </a>

      <a v-else slot="top" href class="btn btn-default btn-lg disabled" disabled style="float:right;margin-left:10px;">
        <i class="fas fa-save"></i> &nbsp; Create micro notes
      </a>

      <router-link :to="{name: 'subject-shelf'}" slot="top" class="btn btn-danger btn-lg" style="float:right;margin-left:10px;">
        <i class="fas fa-arrow-left"></i> &nbsp; Cancel
      </router-link>

      <div class="clearfix"></div>
      <div class="pull-left" style="margin-top: 10px;">
        <Help :showhelp="showHelp">
          <div slot="content">
            Split your lecture notes into micro notes with the <span class="btn btn-default"><span class="fa fa-minus"></span></span> button. Select keywords to be hidden/tested with the <span class="btn btn-default"><span class="fa fa-key"></span></span> button.<br />
            Click an image and select <span class="btn btn-default"><span class="fa fa-object-group"></span></span> to convert the image to a micro note. Image keywords can be set in the next stage.<br />
            Click <span class="btn btn-default"><span class="fa fa-save"></span> Create micro notes</span> to save and proceed to micro note image editing.
          </div>
        </Help>
      </div>

      <div class="text-right pull-right">
        <KeywordSettings v-if="lectureNote" :chapterId="lectureNote.chapter_id" />
      </div>
      <div class="clearfix"></div>
    </PageHeader>

    <div class="main-content container-fluid">
      <div class="row height-100">
        <div class="col-md-12 height-100">
          <div class="height-100-minus" v-if="lectureNote">
            <div v-if="showReplaceWarning" class="bg-danger clearfix">
              <p class="pull-left">
                <b>Warning:</b> You've created {{ lectureNote.micro_note_count }} micro notes based on this lecture note. Those micro notes will be deleted. Are you sure you want to proceed?
              </p>
              <div class="pull-right">
                <a v-on:click.prevent="replaceMicroNotes" href class="btn btn-default btn-sm" style="float: right">
                  Replace
                </a>
                <a v-on:click.prevent="toggleReplaceWarning" href class="btn btn-default btn-sm btn-margin" style="float: right">
                  Cancel
                </a>
              </div>
            </div>
            <FroalaEditor ref="editor" :chapterId="lectureNote.chapter_id" @change="saveLectureNote" :config="froalaConfig" v-model="lectureNote.html" :image-created-function="imageCreated" />

            <a v-if="lectureNote && microNotable()" slot="top" v-on:click.prevent="convertToMicroNotes" href class="btn btn-primary btn-lg" style="float:right;margin-left:10px;">
              <i class="fas fa-save"></i> &nbsp; Create micro notes
            </a>

            <a v-else slot="top" href class="btn btn-default btn-lg disabled" disabled style="float:right;margin-left:10px;">
              <i class="fas fa-save"></i> &nbsp; Create micro notes
            </a>
          </div>
          <div v-else><LoadingIndicator /></div>
          
        </div><!-- /.col -->
      </div><!-- /.row -->
    </div><!-- /.main-content -->
  </div>


</template>


<script>
  import { mapState, mapActions, mapGetters, mapMutations } from 'vuex'
import froalaConfig from '../froala-editor/config/lecture-note-editor.js'
import LectureNote from '../../resources/lectureNote'
import Chapter from '../../resources/chapter'
// import { mapState, mapActions, mapGetters, mapMutations } from 'vuex'
import moment from 'moment'
import FroalaEditor from '../froala-editor/FroalaEditor'
import router from '../../router'
import KeywordSettings from '../micro-note-editor/KeywordSettings'


export default {
  components: {
    FroalaEditor,
    KeywordSettings,
    },
    

    created() {
      this.$store.dispatch('getChapters')

    // Fetch Lecture Note from server
    this.getLectureNote();
  },

  methods: {
    // Since this data is only used on this page, I don't think we need the store
    getLectureNote() {
      const self = this;
      const id = this.$route.params.id;
      if (id) {
        console.log(`Fetching lecture note ${id}...`)
        LectureNote.get({ id }).then((res) => {
          self.lectureNote = res.data;
        }, (res) => {
          Toast.error('Error, failed to retrieve lecture note', res)
        })
      }
    },

    saveLectureNote() {
      const _this = this;
      this.status = 'saving';
      LectureNote.update({id: this.lectureNote.id}, {lecture_note: this.lectureNote}).then((res) => {
        _this.status = 'saved';
      }, (res) => {
        Toast.error('Failed to save changes')
      })
    },

    imageCreated() {
      this.imageCount += 1;
    },

    toggleReplaceWarning() {
      this.showReplaceWarning = !this.showReplaceWarning;
    },

    replaceMicroNotes() {
      LectureNote.update({id: this.lectureNote.id}, {lecture_note: Object.assign(this.lectureNote, {replace_micro_notes: true})}).then((res) => {
        Toast.success('Micro Notes replaced')
        router.push({ name: 'subject-shelf'});
      }, (res) => {
        Toast.error('Failed to save changes')
      })
    },

    convertToMicroNotes() {
      LectureNote.update({ id: this.lectureNote.id }, { lecture_note: Object.assign(this.lectureNote, { create_micro_notes: true }) }).then((res) => {
        Toast.success('Micro Notes created')
        if (this.imageCount > 0) {
          router.push({ name: 'micro-note-editor', params: { chapterId: this.lectureNote.chapter_id, editType: 'image' } });
        } else {
          router.push({ name: 'subject-shelf' });
        }
      }, (res) => {
        Toast.error('Failed to save changes')
      })
    },

    microNotable() { // looks to see that there is content besides html tags in editor, and that there is at least one <hr> element
      return (this.lectureNote.html.replace('/<[^>]*>/','') != '' && this.lectureNote.html.match(/<hr is="divider"\/?>/) != null)
    }
  },

    computed: {
      ...mapGetters({
        chapter: 'studier/chapter',
        chapters: 'allChapters',
      }),

    statusMessage() {
      if( !this.lectureNote) return '';
      if(this.status === 'saving') {
        return 'Saving...';
      } else if(this.status === 'saved') {
        return 'Changes saved.';
      } else {
        return `Last saved ${moment(this.lectureNote.updated_at).fromNow()}`;
      }
    },
  },

  data () {
    return {
      lectureNote: null, // no need for a store since really only this component and it's children are concerned with it (I think?)

      froalaConfig: Object.assign({}, froalaConfig, {
        height: 'calc(100% - 55px)',
      }),
      showReplaceWarning: false,
      status: null, // saving status
      imageCount: 0,
      showInstructions: false,
      showHelp: this.$route.query.help
    }
  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
  .height-100 {
    height: 100%;
  }

  .height-100-minus {
    height: calc(100vh - 278px); /* minus height of panel heading and save btn*/
  }

  .home-link { color: #444444; font-size: 14px; }

  .btn-margin {
    margin-right: 10px;
  }

  .bg-danger {
    background-color: #f2dede;
    padding: 15px;
    margin-bottom: 5px;
  }

  .bg-danger p {
    margin-bottom: 0;
    width: calc(100% - 150px);
  }

  
</style>



// WEBPACK FOOTER //
// LectureNoteEditor.vue?166d6773